import { Tabs } from 'antd';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SystemMenuId } from '../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { PriceModelSetting } from './model-setting';
import getFormatMessage from '../../../locales/get-format-message';
import { ICommonSupportPageProps } from '../../../model';

export const AdminPriceCalculator = (props: ICommonSupportPageProps) => {
  const { site } = props;
  const [currentTab, setCurrentTab] = useState<string>('ModelSetting');

  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.PriceCalculator,
  });
  const handleTabChange = (key: SetStateAction<string>) => {
    setCurrentTab(key);
  };

  return (
    <div>
      <Tabs activeKey={currentTab} onChange={handleTabChange}>
        <Tabs.TabPane
          tab={getFormatMessage('model_setting')}
          key="ModelSetting"
        >
          <PriceModelSetting site={site} />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};
